import { createContext, useContext, useEffect, useState } from "react";

const KEYS = {
  people: "gdt_people",
  departments: "gdt_departments",
  designations: "gdt_designations",
  tasks: "gdt_tasks",
  problems: "gdt_problems",
  meetings: "gdt_meetings",
  settings: "gdt_settings",
};
const DEFAULTS = {
  people: [], departments: [], designations: [], tasks: [], problems: [], meetings: [],
  settings: { problemHours: 48 },
};

const load = (k) => {
  try {
    const v = localStorage.getItem(KEYS[k]);
    return v ? JSON.parse(v) : DEFAULTS[k];
  } catch {
    return DEFAULTS[k];
  }
};

const Ctx = createContext(null);

export const StoreProvider = ({ children }) => {
  const [data, setData] = useState(() =>
    Object.fromEntries(Object.keys(KEYS).map((k) => [k, load(k)])),
  );
  useEffect(() => {
    Object.keys(KEYS).forEach((k) => localStorage.setItem(KEYS[k], JSON.stringify(data[k])));
  }, [data]);

  const set = (key, fn) => setData((d) => ({ ...d, [key]: fn(d[key]) }));
  const api = {
    ...data,
    set,
    add: (key, item) => set(key, (l) => [{ ...item, id: uid() }, ...l]),
    update: (key, id, item) => set(key, (l) => l.map((x) => (x.id === id ? { ...x, ...item } : x))),
    remove: (key, id) => set(key, (l) => l.filter((x) => x.id !== id)),
    setData,
  };
  return <Ctx.Provider value={api}>{children}</Ctx.Provider>;
};

export const useStore = () => useContext(Ctx);

export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

const pad = (n) => String(n).padStart(2, "0");
export const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayISO = () => toISO(new Date());
export const nowLocalDT = () => {
  const d = new Date();
  return `${toISO(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const parseISO = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const fmtDate = (s) =>
  s ? parseISO(s.slice(0, 10)).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "";
export const fmtDT = (s) =>
  s ? new Date(s).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "";

export const achievement = (t) => {
  const target = Number(t.target);
  return target > 0 ? (Number(t.actual) / target) * 100 : null;
};
export const achColor = (p) =>
  p == null ? "text-zinc-500" : p >= 100 ? "text-emerald-400" : p >= 70 ? "text-amber-300" : "text-rose-400";

export const isOverdue = (p, hours) =>
  p.status !== "Solved" && Date.now() - new Date(p.datetime).getTime() > Number(hours) * 3600 * 1000;
